export default "__VITE_ASSET__CWGdM_gO__"